import { render, staticRenderFns } from "./MyTrucks.vue?vue&type=template&id=22b2905e&scoped=true&"
import script from "./MyTrucks.vue?vue&type=script&lang=js&"
export * from "./MyTrucks.vue?vue&type=script&lang=js&"
import style0 from "./MyTrucks.vue?vue&type=style&index=0&id=22b2905e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b2905e",
  null
  
)

export default component.exports